import { AppState } from "../idp-auth";
import { UnifiedProvisionPlanError } from "./constants";
import { UnifiedProvisionEligibilityResult } from "./context";
import { fetchUnifiedLink, UnifiedProvisionPlanResponse } from "./fetch";

export const acceptTeammateInvite = async (
  access_token: string,
  id_token: string,
  appState?: AppState
) => {
  const acceptToken = appState?.token;
  if (!acceptToken) return;

  const unifiedLinkResponse = await fetchUnifiedLink(access_token, acceptToken, id_token);
  if (!unifiedLinkResponse) return; // Success case

  const { status, errors } = unifiedLinkResponse;
  const { error_id = "ERR_TEAMMATE_INVITE_INTERNAL", message = "An unknown error occurred" } =
    errors?.[0] || {};

  throw new Error(`Error ${status}: ${error_id}: ${message}`);
};

export const makeSureUserCanLink = (
  response: UnifiedProvisionPlanResponse
): UnifiedProvisionEligibilityResult => {
  if (!response.eligible) {
    return {
      eligible: response.eligible,
      error: response?.reason as UnifiedProvisionPlanError | undefined,
      has_mfa_exemption: response.has_mfa_exemption,
    };
  }

  return {
    eligible: response.eligible,
    email: response.email,
    has_mfa_exemption: response.has_mfa_exemption,
  };
};
